<template>
	<router-view></router-view>
</template>

<script>
export default {
	name: 'App',
	created() {
		// 解决IE不能监听hash和参数变化
        if (!!window.ActiveXObject || 'ActiveXObject' in window) {
            window.addEventListener('hashchange', () => {
                let currentPath = location.hash.slice(1);
                if (this.$route.path !== currentPath) {
                this.$router.push(currentPath);
                }
            }, false);
        }
	}
};
</script>
